import { BaseEntityService } from '/@/modules/core/app/services/abstracts/BaseEntityService';
import { Route } from '/@/modules/core/app/constants/api.constants';
import { TypeformForm } from '/@/modules/typeform/models/TypeformForm';
import { BaseModelType } from '@/modules/core/app/models/abstracts/BaseModel';

export class TypeformFormEntityService extends BaseEntityService<TypeformForm> {
  getRoute(): Route {
    return Route.TYPEFORM_FORMS;
  }

  getModel(): BaseModelType<TypeformForm> {
    return TypeformForm;
  }
}

export default new TypeformFormEntityService();
